<style lang="scss" scoped>
.static-card {
    border: none;
    color: inherit;
    margin: 0px;
    text-align: inherit;
    text-decoration: none;
    position: relative;

    .media-container {
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        .ar {
            position: relative;
            background-position: 50% 50%;
            background-repeat: no-repeat;

            .images {
                position: absolute;
                top: 0px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    border-radius: 4px;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    font-family: "object-fit: cover;";
                }

                .primary-image {
                    z-index: 9;
                }

                .crossfade-to-images {
                    position: absolute;
                    top: 0;
                    z-index: 10;
                }

                .crossfade-from-images {
                    position: absolute;
                    top: 0;
                    z-index: 11;
                }                
            }
        }
    }
    .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    .subtitle {
        font-size: 12px;
    }
}
</style>

<template>
    <component :is="staticItemInterface.cta_kind && linkIsValid ? 'a': 'div'" class="static-card d-inline-flex flex-column justify-content-between" :href="staticItemInterface.cta_kind && linkIsValid ? (staticItemInterface.cta_kind === 'link' ? `/${staticItemInterface.cta_link}` : route('nl.category',  {'slug': staticItemInterface.cta_category.slug})) : null">
        <div class="position-relative">
            <div class="media-container mb-12" ref="card">
                <div ref="ar" class="ar" :style="{ 'padding-top' : fixedHeight ? `${fixedHeight}px` : `${ arHeight / arWidth * 100 }%` }">
                    <div class="images">
                        <template v-if="staticItemInterface.image">
                            <img class="primary-image" ref="primary" :src="staticItemInterface.image.sizes.medium_large" :alt="staticItemInterface.title">
                        </template>
                    </div>
                </div>
            </div>
            <p class="title lh-1">{{ staticItemInterface.title }}</p>
            <p v-if="staticItemInterface.description" class="text-dark font-weight-light small mt-8 subtitle">
                {{ staticItemInterface.description }}
            </p>
        </div>
        <button v-if="staticItemInterface.cta_kind != null && staticItemInterface.cta_kind != '' && linkIsValid" class="btn btn-accent mt-32 align-self-start">{{ staticItemInterface.cta }} <span v-html="svg('arrow-right', 'arrow-right')" /></button>
    </component>
</template>

<script>
export default {
    name: "elements.static-card",

    props: {
        staticItem: {
            type: Object,
            required: false,
            default: () => {
                return {
                    categories: []
                }
            }
        },
        ratio: {
            type: [String, Boolean],
            default: '181:240',
            required: false
        },
        fixedHeight: {
            type: [Number],
            required: false,
            default: null,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        }
    },

    computed: {
        staticItemInterface() {
            if (this.staticItem.ID != null) {
                let intfc = this.staticItem.acf;
                intfc.cta_kind = intfc.cta_type;
                intfc.title = this.staticItem.post_title;
                intfc.id = this.staticItem.id;

                if (intfc.cta_type == 'category') {
                    let filteredCategory = this.pages.filter(p => p.id == this.staticItem.acf.cta_category[0]);
                    if (filteredCategory.length > 0) {
                        let slug = filteredCategory[0].slug;
                        intfc.cta_category = {
                            slug: slug
                        };
                    }
                } else {
                    intfc.cta_category = {
                        slug: ''
                    };
                }

                return intfc;
            }
            return this.staticItem;
        },

        linkIsValid() {
            let intfc = this.staticItemInterface;

            if (intfc.cta_kind === 'category' && intfc.cta_category && intfc.cta_category.slug != '') {
                return true;
            }

            if (intfc.cta_kind === 'link' && intfc.cta_link != '') {
                return true;
            }

            return false;
        },

        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },

        actualHeight() {
            return this.$refs.primary.clientHeight
        }
    }
}
</script>